import { render, staticRenderFns } from "./userAuthApp.vue?vue&type=template&id=47e7db07&"
import script from "./userAuthApp.vue?vue&type=script&lang=js&"
export * from "./userAuthApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports